import { render, staticRenderFns } from "./textarea-field.component.vue?vue&type=template&id=672f8244&scoped=true&"
import script from "./textarea-field.component.ts?vue&type=script&lang=ts&"
export * from "./textarea-field.component.ts?vue&type=script&lang=ts&"
import style0 from "./textarea-field.component.scss?vue&type=style&index=0&id=672f8244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f8244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
